import React, { Component } from "react";
import { Link } from "react-router-dom";

class TermsOfSales extends Component {

    render() {
        return (
            <div className="terms">
                <div className="container">
                    <ol className="breadcrumb">
                        <li><a href="/">Home &gt; </a></li>
                        <li className="active">Terms and Conditions</li>
                    </ol>
                    <section className="page-title center">
                        <h1 className="uppercase">Terms and Conditions</h1>
                    </section>

                    <section className="block">
                        <div className="container">
                            <div className="section-title">
                                <div className="description custom-header">
                                    <h2>1. Introduction to UK Tax & Salary Assist</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-sm-12">
                                    <p>
                                        Welcome to UK Tax & Salary Assist, a website and mobile application operated by Innovotech Solutions LTD, a company
                                        registered in England & Wales (company number: 10641546).
                                    </p>
                                    <p><b>'UK Tax & Salary Assist' is a trading name for Innovotech Solutions Ltd, a company
                                        registered in England & Wales (company number: 10641546). Our registered
                                        office address is at 128 City Road, London, England, EC1V 2NX, United Kingdom</b>.</p>
                                    <p>"UK Tax & Salary Assist","TaxAssistant" "The Company", “Ourselves”, “We”, “Our” and "Us", refers to
                                        our company, <b>Innovotech Solutions Ltd.</b></p>
                                    <p>
                                        By using our Service, you agree to be bound by these terms and conditions. If you do not agree to these terms and conditions, you may not use our Service.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="block">
                        <div className="container">
                            <div className="section-title">
                                <div className="description custom-header">
                                    <h2>2. Our Service</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-sm-12">
                                    <p>
                                        The UK Tax & Salary Assist app is a tax assistance tool that helps users calculate their UK taxes, salary breakdowns, and financial planning details through AI-powered technology. The app assists with complex UK tax calculations and offers helpful financial summaries.
                                    </p>
                                    <p>
                                        Users can input salary, dividends, rental income, and other relevant details. The app will estimate taxes, national insurance contributions, and potential deductions based on current UK tax laws.
                                    </p>
                                    <p>
                                        Please note that the app relies on real-time data and may not function if third-party services are unavailable. Innovotech Solutions LTD shall not be held liable for any inability to use the app due to external service disruptions.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="block">
                        <div className="container">
                            <div className="section-title">
                                <div className="description custom-header">
                                    <h2>3. Your Personal Data and Privacy</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-sm-12">
                                    <ul className="bulleted">
                                        <li> We collect only necessary tax calculation data for app functionality. </li>
                                        <li> We do <u>NOT</u> collect sensitive personal data such as National Insurance numbers or banking details. </li>
                                    </ul>
                                    <p><b>Please read our
                                        <Link to="/privacy-policy"> Privacy Policy </Link> for further details.</b></p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="block">
                        <div className="container">
                            <div className="section-title">
                                <div className="description custom-header">
                                    <h2>4. Limitations</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-sm-12">
                                    <ul className="bulleted">
                                        <li>In no event shall we be liable for any damages whatsoever, including but not limited to direct, indirect, special, incidental, or consequential damages arising from the use or inability to use the Service.</li>
                                    </ul>
                                    <p className="ask_ai_disclaimer"><b>Disclaimer:</b> As an AI-powered language model, TaxAssistant can make mistakes. Always consult a tax professional for personalised advice.</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="block">
                        <div className="container">
                            <div className="section-title">
                                <div className="description custom-header">
                                    <h2>9. Contacting Us</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-sm-12">
                                    <p><b> You can contact us via info@websafe365.com</b></p>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        );
    };
}

export default TermsOfSales;
